export const statusMap: any = {
    1: 'PENDING',
    2: 'REVISED',
    3: 'REJECTED',
    4: 'APPROVED'
  };